import { ModalContentProps } from "./types"
import { oysterClassNames } from "../utils/oysterClassNames"

export function ModalContent({ children, className, ...rest }: ModalContentProps) {
  const _className = oysterClassNames("overflow-y-auto px-4 only-of-type:mt-5 md:px-5", className)
  return (
    <div className={_className} data-testid="modal-body" {...rest}>
      {children}
    </div>
  )
}
